import { useMutation } from 'react-query';
import { authFetch } from '../../../../../../CommonUtils/authFetch';
import { validateImage } from '../../../utils/validateImage';
import { urlWithParams } from '../../../../../../CommonUtils/urlWithParams';
import { logo } from '../FirmLogo.meta';

interface UploadLogoParams {
  file: File;
}

const uploadLogo = async ({ file }: UploadLogoParams): Promise<string> => {
  await validateImage(file, logo.maxFileSize, logo.formattedMaxFileSize);

  const { signedUrl, logoFileName } = await authFetch(
    urlWithParams('/Adviser/Logo/GetUploadToken', { filename: file.name, filetype: file.type }),
  );

  await fetch(signedUrl, { method: 'PUT', body: file });

  return logoFileName;
};

export const useUploadLogoMutation = () => {
  return useMutation(uploadLogo);
};
